import React, { useEffect, useState } from "react"

import { getContactsSummary } from "@actions/contactActions"
import { Caption } from "@assets/styles/typographyStyles"

import { DeviceSyncedWrapper } from "./contactsStyles"

// ACCOUNT-STATE bug B(ii) (2026-07-04): the account's mobile app has synced device contacts to
// the server for years, entirely independent of any web Google connector -- Sync Contacts used
// to look identical to a brand-new, never-synced account for a user in that shape. This row
// shows the account's REAL existing synced state (small, honest, additive: never replaces the
// connector list above, never invents a fake connector). Renders nothing while loading or if the
// account genuinely has zero server-side contacts -- never a fabricated "0 synced" claim.
export const DeviceSyncedRow = () => {
  const [summary, setSummary] = useState(null)

  useEffect(() => {
    let cancelled = false
    getContactsSummary().then(data => {
      if (!cancelled) setSummary(data)
    })
    return () => {
      cancelled = true
    }
  }, [])

  if (!summary || !summary.deviceSynced) return null

  return (
    <DeviceSyncedWrapper data-testid="deviceSyncedContactsRow">
      <Caption>
        Contacts synced from your devices: {summary.deviceSynced}
      </Caption>
    </DeviceSyncedWrapper>
  )
}
